<!-- Main menu -->
@if (isAuthenticated()) {
    @if (!isHeaderHidden()) {
        <header-top-menu></header-top-menu>
    }
    @if (!isSidemenuHidden()) {
        <app-sidemenu></app-sidemenu>
    }
}

<main id="main-content" class="view-container" role="main" [attr.aria-label]="'global.mainContent' | translate">
    <!-- TODO: Plantearse eliminar este ngClass, ya que no hace nada y funciona todo correctamente -->
    <div
        class="view-frame"
        data-ng-class="{'view-frame--sidemenu-semi-hidden' : !$root.isSidemenuHidden && (!$root.isSidemenuVisible || $root.isCategoryContainerOpened), 'view-frame--inmobile' : !$root.isSidemenuHidden && $root.inmobile, 'movementMenu' : !$root.movementMenu  }">
        <router-outlet></router-outlet>
    </div>
</main>
